import './PodcastEmbed.css';

interface PodcastEmbedProps {
  type: 'video' | 'audio';
  title: string;
  description?: string;
  youtubeId?: string;
  audioUrl?: string;
  date?: string;
}

export function PodcastEmbed({ type, title, description, youtubeId, date }: PodcastEmbedProps) {
  return (
    <div className="podcast-embed">
      {type === 'video' && youtubeId ? (
        <div className="podcast-embed__video">
          <iframe
            src={`https://www.youtube.com/embed/${youtubeId}`}
            title={title}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        </div>
      ) : (
        <div className="podcast-embed__audio-placeholder">
          <i className="fas fa-podcast"></i>
          <span>Audio episode coming soon</span>
        </div>
      )}
      <div className="podcast-embed__info">
        <h3 className="podcast-embed__title">{title}</h3>
        {date && <span className="podcast-embed__date">{date}</span>}
        {description && <p className="podcast-embed__description">{description}</p>}
      </div>
    </div>
  );
}
